import { ErrorOutlineOutlined } from "@mui/icons-material"
import type { BoxProps } from "@mui/material"
import {
  DashboardInfoBanner,
  DashboardInfoBannerCaption,
  DashboardInfoBannerGroup,
  DashboardInfoBannerLink,
  type DashboardInfoBannerProps,
  DashboardInfoBannerTitle,
  useDialog,
} from "@pharmupp/p3-front-commons"
import { HelpCircle } from "react-feather"
import { NegativeModal } from "./NegativeModal"

export const MyNegativeSegmentationBanner = ({
  centralBusinessId,
  cipCode,
  ...props
}: { centralBusinessId: string; cipCode: string } & Omit<BoxProps, "mb"> &
  Pick<DashboardInfoBannerProps, "size" | "iconSize" | "offset">) => {
  const dialog = useDialog()

  return (
    <DashboardInfoBanner {...props} variant="negativeSegmentation">
      <ErrorOutlineOutlined />
      <DashboardInfoBannerGroup>
        <DashboardInfoBannerCaption>{`ID : ${centralBusinessId}`}</DashboardInfoBannerCaption>
      </DashboardInfoBannerGroup>
      {" - "}
      <DashboardInfoBannerGroup>
        <DashboardInfoBannerCaption>{`CIP : ${cipCode}`}</DashboardInfoBannerCaption>
      </DashboardInfoBannerGroup>
      <DashboardInfoBannerGroup>
        <DashboardInfoBannerTitle color="negativeSegmentation.main">
          Votre pharmacie est en segmentation négative
        </DashboardInfoBannerTitle>
        <DashboardInfoBannerCaption>&nbsp;:</DashboardInfoBannerCaption>
      </DashboardInfoBannerGroup>
      <div>
        <DashboardInfoBannerCaption>
          le versement des primes Vie des UPP et des points Challenges est donc
          suspendu.
        </DashboardInfoBannerCaption>
        &nbsp;
        <DashboardInfoBannerLink
          onClick={() =>
            dialog.info({
              message: <NegativeModal />,
              title: "Pharmacie en segmentation négative",
              validateText: "J'ai compris",
              width: "75vw",
              Icon: HelpCircle,
            })
          }
        >
          En savoir +
        </DashboardInfoBannerLink>
      </div>
    </DashboardInfoBanner>
  )
}
